import {AfterViewInit, Component, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {language} from '../../../language/vn';
import {FormGroup, FormControl, FormBuilder, Validators} from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import {first} from 'rxjs/operators';
import {BsModalRef } from 'ngx-bootstrap/modal';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-decoupled-document';
import {Subject} from 'rxjs';
import {ThietBi} from '../../../models/danhmuc/thietbi';
import {DangKyService} from '../../../service/vpp/service-dangky';
import {ThietBiService} from '../../../service/danhmuc/service-thietbi';
import {DatePipe} from '@angular/common';
import {CommandUtil} from '../../../global/commandutil';
import {Sessioncommand} from '../../../global/sessioncommand';
import {DangKyNguoiDuyetService} from '../../../service/vpp/service-dangkynguoiduyet';
import {DangKyNguoiDuyet} from '../../../models/vpp/dangkynguoiduyet';
import {DangKy} from '../../../models/vpp/dangky';

;

@Component({
  templateUrl: './confirmpd.component.html'

})
export class ConfirmPDDangKyComponent implements OnInit, AfterViewInit {

  public language = language;
  public id: number=0;
  public frmGroup: FormGroup;
  public isEdit: boolean = false;
  public submitValidate = false;
  public editor = ClassicEditor;
  public dataThietBi: ThietBi[];
  public gio: String = '';
  public itemDangKy: DangKy = new DangKy();
  public onClose: Subject<boolean>;
  constructor( public dangKyService: DangKyService,
               public formBuilder: FormBuilder,
               public toastr: ToastrService,
               public thietBiService: ThietBiService,
               public _bsModalRef: BsModalRef,
               public datepipe: DatePipe,
               public commandUitls: CommandUtil,
               public dangKyNguoiDuyetService: DangKyNguoiDuyetService

  ) {
  }
  ngAfterViewInit() {

  }
  public onReady( editor ) {
    editor.ui.getEditableElement().parentElement.insertBefore(
      editor.ui.view.toolbar.element,
      editor.ui.getEditableElement()
    );
    editor.editing.view.change( writer => {
      writer.setStyle( 'height', '300px', editor.editing.view.document.getRoot() );
      writer.setStyle( 'border', '1px solid', editor.editing.view.document.getRoot() );
    } );
  }
  ngOnInit(): void {
    this.onClose = new Subject();
    this.frmGroup = new FormGroup({
      dangKyId: new FormControl('0'),
      ngay: new FormControl(),
      ghiChu: new FormControl(''),
      phongID: new FormControl(0),
      noiDung: new FormControl(),
      thoiGian: new FormControl(),
      pheDuyet: new FormControl(),
      nguoiChuTri: new FormControl(),
      nguoiDangKyID: new FormControl(),
      trangThai: new FormControl(1)
    });
    this.frmGroup = this.formBuilder.group({
      dangKyId:['', Validators.nullValidator],
      ngay: ['', Validators.nullValidator],
      noiDung:['', Validators.nullValidator],
      ghiChu: ['', Validators.nullValidator],
      thoiGian: ['', Validators.nullValidator],
      phongID: ['0', Validators.nullValidator],
      pheDuyet: ['', Validators.nullValidator],
      nguoiChuTri: ['', Validators.nullValidator],
      nguoiDangKyID: ['', Validators.nullValidator],
      trangThai: ['', Validators.nullValidator]
    });

    this.thietBiService.getAll().subscribe(data => this.dataThietBi = data);


  }
  get f() { return this.frmGroup.controls; }
  public edit(id: number) {
    this.id = id;
    this.dangKyService.getById(id).pipe(first())
      .subscribe(x => {
        this.itemDangKy = x;
        this.frmGroup.patchValue(x);
      });
  }

  public updateItem()
  {
    this.frmGroup.value.trangThai= this.isEdit === true ? 3 : 2;
    this.dangKyService.approved(this.frmGroup.value).subscribe({
      next: (data) => {
        let dangKyNguoiDuyetItem : DangKyNguoiDuyet = new DangKyNguoiDuyet();
        dangKyNguoiDuyetItem.staffId = Sessioncommand.staffId;
        dangKyNguoiDuyetItem.dangKyId = data.dangKyId;
        dangKyNguoiDuyetItem.noiDung = this.frmGroup.value.pheDuyet;
        dangKyNguoiDuyetItem.status = data.trangThai;
        dangKyNguoiDuyetItem.typeDK = 1;
        this.dangKyNguoiDuyetService.approved(dangKyNguoiDuyetItem).subscribe(
          {
            next: (dtnd ) => {
            },
            error: error => {
            }
          }
        );
        this.toastr.success(this.isEdit==true? language.approve_success_message : language.reject_success_message, language.message);
        this.onConfirm();
      },
      error: error => {
        this.toastr.error(language.error, language.message);
      }
    });
  }

  onSubmit()
  {

    this.submitValidate = true;
    if (this.id != 0)
      this.updateItem();

  }
  public onConfirm(): void {

    this.onClose.next(true);
    this._bsModalRef.hide();
  }

  public onCancel(): void {
    this.onClose.next(false);
    this._bsModalRef.hide();
  }

  public hideConfirmationModal(): void {
    this.onClose.next(null);
    this._bsModalRef.hide();
  }

}

